/** Support email for user assistance */
export const SUPPORT_EMAIL = "support@wrap.gifts";

/** Standard "Need help?" message with support contact */
export const NEED_HELP_MESSAGE = `Need help? Contact ${SUPPORT_EMAIL}`;

/** Copyright year for footer and legal notices - calculated automatically */
export const COPYRIGHT_YEAR = new Date().getFullYear();
